export const FACEBOOK_TOASTS = {
  CREATED_FACEBOOK_TOASTS:
        'Your ads have been successfully scheduled. You will receive an email when your ads have been successfully published.',
  CREATED_ERROR_OCCURRED:
        'There was an error uploading your ads. Please try again or contact customer support',
};
